import type { ChartType, SelectableChartType } from './types/chart';

const selectableChartTypes: Record<SelectableChartType, boolean> = {
  bar: true,
  'stacked-bar': true,
  'grouped-bar': true,
  'diverging-bar': true,
  'diverging-bar-combo': true,
  line: true,
  treemap: true,
  volume: true,
  box: true,
  sankey: true,
  chord: true,
  distribution: true,
  map: true,
  table: true,
  text: true,
  'gauge-v2': true,
  'ai-summary': true,
  icicle: true,
};

export const SELECTABLE_CHART_TYPES = Object.keys(
  selectableChartTypes
) as readonly SelectableChartType[];

export const isSelectableChartType = (
  chartType: ChartType | undefined
): chartType is SelectableChartType =>
  selectableChartTypes[chartType as SelectableChartType];
